/* eslint-disable indent */
import { createGlobalStyle } from 'styled-components';

export const HideDomElements = createGlobalStyle`
    #side-menu,
    .container-fluid,
    .product-menu,
    .wrap-theme,
    ${({ hideGrid }) => hideGrid ? '.i3x-component-overlay,' : ''}
    footer { display: none !important; }
`;

export const HideBodyOverflow = createGlobalStyle`
    html, body { overflow: hidden; }
`;

export const SetHtmlBodyHeight = createGlobalStyle`
    html, body {
        height: 100vh;
        margin: 0;
    }
`;
